import { create } from 'zustand';
/**
 * 앱 내 전역적으로 포커스 된 띠를 관리합니다.
 * @param set
 */
var focusedBoard = create(function (set) { return ({
    setFocusedBoard: function (boardType) {
        set(function () { return ({
            focusedBoard: boardType,
        }); });
    },
}); });
export var useFocusedBoardStore = focusedBoard;
